import { useEffect } from 'react';

import type React from 'react';

export const useAsyncEffect = (
  asyncCallback: () => Promise<void | (() => void)>,
  dependencies: React.DependencyList,
) => {
  useEffect(() => {
    let isMounted = true;

    const execute = async () => {
      const cleanup = await asyncCallback();
      if (isMounted && typeof cleanup === 'function') {
        return cleanup;
      }
    };

    execute();

    return () => {
      isMounted = false;
    };
  }, dependencies);
};
